module.exports = require('./emitQueryDataUpdate')
